import { throttle } from '@/core';
import {
	getOrderTemplatesRequest,
	newOrderTemplateRequest,
	deleteOrderTemplateRequest,
	updateOrderTemplateRequest,
	calculateNextOrderRequest,
	getGeneratedOrdersRequest
} from '../requests';
import rdbClient from 'rdb-client';

async function getOrderTemplates({ state, commit }, refresh = false) {
	commit('setLoading', true);
	try {
		if (state.orderTemplates.length === 0 || refresh) {
			await fetchOrderTemplates();
		} else {
			await throttle( async() => fetchOrderTemplates, 'fetchOrderTemplates', 60 * 1000);
		}
	} catch (err) {
		throw new Error('failedToFetch');
	}
	commit('setLoading', false);

	async function fetchOrderTemplates() {
		let templates = await getOrderTemplatesRequest();
		commit('setOrderTemplates', templates);
	}
}

async function deleteTemplates({ state, commit }, ids) {
	try {
		for (let id of ids) {
			await deleteOrderTemplateRequest(id);
		}
		let updatedTemplates = state.orderTemplates.filter( (template) => ids.indexOf(template.id) < 0);
		commit('setOrderTemplates', updatedTemplates);
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function saveOrderTemplate({ state: { orderTemplates, templateDetails }, commit }) {
	let newOrderTemplate = JSON.parse(JSON.stringify(templateDetails));
	let oldOrderTemplate = orderTemplates.find( (x) => x.id === newOrderTemplate.id);

	if (oldOrderTemplate) {
		try {
			let patch = rdbClient.createPatch(oldOrderTemplate, newOrderTemplate);
			await updateOrderTemplateRequest(newOrderTemplate.id, { patch });
			let updatedOrderTemplates = [...orderTemplates];
			updatedOrderTemplates[updatedOrderTemplates.indexOf(oldOrderTemplate)] = newOrderTemplate;
			commit('setOrderTemplates', updatedOrderTemplates);
		} catch (err) {
			throw new Error('failedToUpdate');
		}
	} else {
		try {
			let response = await newOrderTemplateRequest(newOrderTemplate);
			newOrderTemplate.id = response.id;
			commit('setOrderTemplates', [ ...orderTemplates, newOrderTemplate ]);
		} catch (err) {
			throw new Error('failedToCreate');
		}
	}
}

async function findNextOrder({ state, commit }) {
	try {
		let nextOrder = await calculateNextOrderRequest(state.templateDetails);
		commit('updateTemplateDetails', { key: 'nextOrder', value: nextOrder });
	} catch (err) {
		throw new Error('failedToCalculate');
	}
}

async function fetchGeneratedOrders({ state, commit }) {
	try {
		let generatedOrders = await getGeneratedOrdersRequest(state.templateDetails.generatedOrders);
		commit('setGeneratedOrders', generatedOrders);
	} catch (err) {
		throw new Error('failedToFetch');
	}
}

export default {
	getOrderTemplates,
	deleteTemplates,
	saveOrderTemplate,
	findNextOrder,
	fetchGeneratedOrders
};